exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hidden_input[data-v-740e4afc]{display:none}.yandex_form__submit[data-v-740e4afc]{position:relative;display:block;width:220px;height:50px;margin:auto;outline:none;border:none;border-radius:10px;box-shadow:0 0 1px #333;cursor:pointer;text-align:center;color:#353b31;background:linear-gradient(180deg,#ffe900,#ffcf01);font-size:22px;font-style:italic;font-weight:700;font-family:PTSansExportBase,sans-serif}.yandex_form__submit[data-v-740e4afc]:hover{box-shadow:0 0 3px #333}", ""]);

// exports
